import { overlayBgClasses } from '@/components/OverlayControlButton'
import RecordScreenIcon from '@/CustomIcons/RecordScreenIcon'
import SessionLimitCountdown from './SessionLimitCountdown'
import useSessionLimitCountdownService from './useSessionLimitCountdownService'
import { useCloudRecording } from '@/services/useCloudRecording'
import { cn } from '@/utlis/cn'
import { StudioRoomOverlayControls } from './StudioRoomOverlayControls'
import { useRoomContext } from '@/RoomContext'
import { isReordering, sessionViewModeState, useViewMode } from '../shared/useViewMode'
import { Button } from '@/UIComponents2/Button'

export default function GalleryTopBar({ debugRender, className }: { debugRender?: boolean; className?: string }) {
    const [roomState] = useRoomContext()
    const { showTimer, canBoost, remainingTimeS } = useSessionLimitCountdownService()
    const { isCloudRecording, cloudRecordingStarting } = useCloudRecording()

    const hasSubrooms = roomState.subrooms?.length > 0
    const renderStudioSwitcher = (roomState.isHost && roomState.isSubroomsEnabled) || hasSubrooms
    const viewMode = useViewMode()
    const reordering = isReordering(viewMode)

    const hasContents =
        showTimer || isCloudRecording || cloudRecordingStarting || renderStudioSwitcher || debugRender || reordering
    if (!hasContents) {
        return <div /> // Fills top spacer position of the grid in Gallery
    }

    const layout = 'flex items-center px-2 py-1 h-[39px]'
    const bg = 'rounded-[16px]'
    return (
        <div className={cn('relative', className)}>
            <div className="w-full h-[40px]"></div>

            <div className={'absolute top-2 left-3 z-15 flex gap-3 items-center'}>
                {(showTimer || debugRender) && (
                    <div className={cn(layout, bg, overlayBgClasses)}>
                        <SessionLimitCountdown canBoost={canBoost} remainingTimeS={remainingTimeS} />
                    </div>
                )}

                {(debugRender || isCloudRecording) && (
                    <div className={cn(layout, bg, overlayBgClasses)}>
                        <div className="text-muse-fg/65">
                            <RecordScreenIcon className="text-muse-danger pb-0.5 pr-1" style={{ fontSize: '1.1rem' }} />
                            Recording in Progress
                        </div>
                    </div>
                )}

                {!isCloudRecording && cloudRecordingStarting && (
                    <div className={cn(layout, bg, overlayBgClasses)}>
                        <div className="text-gray-400">Starting Cloud Recording...</div>
                    </div>
                )}
            </div>

            {renderStudioSwitcher && <StudioRoomOverlayControls />}

            {(reordering || debugRender) && (
                <div className="absolute top-2 right-5 z-15 flex gap-3 items-center">
                    <Button
                        variant="primary"
                        onClick={() => sessionViewModeState.toggleReorderVideoMode()}
                        className="border-muse-toplit-low flex gap-3 py-[8px]"
                    >
                        Done Reordering
                    </Button>
                </div>
            )}
        </div>
    )
}
